/*!
 * Copyright (c) 2010-2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';
/* Core API */

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var api = {};
module.exports = api;
/* API Constants */

var constants = require('./constants');

Object.assign(api, constants); // TODO: support `ProofChain`

var ProofSet = require('./ProofSet');

api.sign =
/*#__PURE__*/
function () {
  var _sign = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(document) {
    var _ref,
        suite,
        purpose,
        documentLoader,
        expansionMap,
        compactProof,
        url,
        err,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, suite = _ref.suite, purpose = _ref.purpose, documentLoader = _ref.documentLoader, expansionMap = _ref.expansionMap, compactProof = _ref.compactProof;
            _context.prev = 1;
            _context.next = 4;
            return new ProofSet().add(document, {
              suite: suite,
              purpose: purpose,
              documentLoader: documentLoader,
              expansionMap: expansionMap,
              compactProof: compactProof
            });

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

            if (!(!documentLoader && _context.t0.name === 'jsonld.InvalidUrl')) {
              _context.next = 14;
              break;
            }

            url = _context.t0.details.url;
            err = new Error("A URL \"".concat(url, "\" could not be fetched; you need to pass ") + '"documentLoader" or resolve the URL before calling "sign".');
            err.cause = _context.t0;
            throw err;

          case 14:
            throw _context.t0;

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));

  function sign(_x) {
    return _sign.apply(this, arguments);
  }

  return sign;
}();

api.verify =
/*#__PURE__*/
function () {
  var _verify = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(document) {
    var _ref2,
        suite,
        purpose,
        documentLoader,
        expansionMap,
        compactProof,
        result,
        error,
        url,
        err,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, suite = _ref2.suite, purpose = _ref2.purpose, documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap, compactProof = _ref2.compactProof;
            _context2.next = 3;
            return new ProofSet().verify(document, {
              suite: suite,
              purpose: purpose,
              documentLoader: documentLoader,
              expansionMap: expansionMap,
              compactProof: compactProof
            });

          case 3:
            result = _context2.sent;

            if (!documentLoader && result.error) {
              error = result.error;

              if (error.name === 'jsonld.InvalidUrl') {
                url = error.details.url;
                err = new Error("A URL \"".concat(url, "\" could not be fetched; you need to pass ") + '"documentLoader" or resolve the URL before calling "verify".');
                err.cause = error;
                result.error = err;
              }
            }

            return _context2.abrupt("return", result);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  function verify(_x2) {
    return _verify.apply(this, arguments);
  }

  return verify;
}(); // expose suite classes


api.suites = require('./suites').suites; // expose ProofPurpose classes to enable extensions

api.purposes = require('./purposes').purposes; // expose LDKeyPair classes

Object.assign(api, require('crypto-ld')); // expose document loader helpers

Object.assign(api, require('./documentLoader'));